export default "__VITE_ASSET__DbGd_dBD__"